import styled, { css } from 'styled-components'

const iconType = ({ type }) => {
  if (type === 'confirmed') {
    return css`
      background-color: rgba(5, 148, 79, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(5, 148, 79, 1);
      }
    `
  } else if (type === 'rejected') {
    return css`
      background-color: rgba(225, 25, 0, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `
  }
}

export const SpeciesConfirmDeclineListContainer = styled.div`
  width: 100%;
  border-top: 1px solid rgba(32, 32, 32, 0.2);
  border-bottom: ${(p) => {
    return p.lastItem ? '1px solid rgba(32, 32, 32, 0.2)' : 'none'
  }};
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SpeciesConfirmDeclineListHalfSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SpeciesConfirmDeclineListTitleIconWrapper = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 2px;
  display: grid;
  place-items: center;
`

export const SpeciesConfirmDeclineListTitleIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : '#0aa1f4'
  }};
`

export const SpeciesConfirmDeclineListTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-left: 16px;
  color: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const SpeciesConfirmDeclineIcon = styled.div`
  margin-right: 24px;
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  ${iconType}
`

export const SpeciesCalendarIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  margin-right: 8px;
`

export const SpeciesCalendarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 24px;
`

export const SpeciesCalendarDateText = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-bottom: 1px dotted rgba(32, 32, 32, 0.5);

`

export const SpeciesLastReassessmentCalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SpeciesValidationIcon = styled.div`
  position: absolute;
`

export const SpeciesValidationIconWrapper = styled.div`
  position: relative;
  left: 16px;
  
`

export const SpeciesDeleteIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;
  margin-left: 16px;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const SpeciesListTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 32px;
  color: rgba(32, 32, 32, 0.7);
  border-bottom: 1px dotted rgba(32, 32, 32, 0.7);
  margin-top: ${(p) => {
    return p.marginTop
  }};
`
export const SpeciesListTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const SpecieHeaderActionMenuWrapper = styled.div`
  margin-left: 8px;
`

